import { render, staticRenderFns } from "./PhotoGallerySet.vue?vue&type=template&id=6e234fab&scoped=true&"
import script from "./PhotoGallerySet.vue?vue&type=script&lang=js&"
export * from "./PhotoGallerySet.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGallerySet.vue?vue&type=style&index=0&id=6e234fab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e234fab",
  null
  
)

export default component.exports